import reportWebVitals from './reportWebVitals';
import ReactDOM from "react-dom/client";
import TemplateSelector from './TemplateSelector';
import PolicyEditor from './PolicyEditor';
import { Executor } from './Executor';
import { initUploadFields } from './UploadField';
import { initSelectFields } from './components/select'
import { initDatePickerFields, mountDateTimePicker } from './components/datepicker/initDatePickerFields'
import { initChangeFormActions } from './initChangeFormActions'
import ForbiddenError from './exceptions';
import { LdapBrowser } from './LdapTree';
import Stream from "./components/live_translation/Stream";
import { LiveTable, type TableConfig } from "./components/live_table";
import { DonutChart, HalfDonutChart } from "./components/charts";
import { ToastContainer, toast } from "./components/toast";
import { queryClient, persistOptions } from "./components/live_table/queryCache";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import './index.scss'
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import '@rudesktop/rutoken/RutokenTotpFido2Demo/ClientApp/dist/index.esm.css'
import DemoWrapper from '@rudesktop/rutoken';

const router = createBrowserRouter([
    {
        path: "/",
        element: <LdapBrowser />,
    },
    {
        path: "/ldap/tree/",
        element: <LdapBrowser />,
    },
    {
        path: "/automation/policy/add/",
        element: <TemplateSelector />,
    },
    {
        path: "/automation/policy/create/",
        element: <PolicyEditor type_request="create" />,
    },
    {
        path: "/automation/policy/:id/change/",
        element: <PolicyEditor type_request="change" />,
    },
    {
        path: "/forbidden/",
        element: <ForbiddenError />,
    },
]);

const root = document.getElementById("root");
if (root) ReactDOM.createRoot(root).render(<RouterProvider router={router} />);

const executor = document.getElementById("executor");
if (executor) ReactDOM.createRoot(executor).render(<Executor />);

const viewLogs = document.getElementById("view_logs");
if (viewLogs) ReactDOM.createRoot(viewLogs).render(<Executor instance="loadLogs" height="500px" />);

const ldap_tree = document.getElementById("ldap_tree");
if (ldap_tree) ReactDOM.createRoot(ldap_tree).render(<LdapBrowser />);


const rutokenContainer = document.getElementById('rudesktop_mfa_rutoken');
if (rutokenContainer) {
    ReactDOM.createRoot(rutokenContainer).render(<DemoWrapper containerId='rudesktop_mfa_rutoken' modalContainerId="rudesktop_mfa_rutoken_modal" />);;
}

const live_record = document.getElementById("live_record");
if (live_record) {
    const manifestUrl = live_record.getAttribute("data-manifest-url");
    ReactDOM.createRoot(live_record).render(<Stream src={manifestUrl || ""} />);
}

const liveTableRoot = document.getElementById("live-table-root");
if (liveTableRoot) {
    const configStr = liveTableRoot.getAttribute("data-config");
    if (configStr) {
        const tableConfig: TableConfig = JSON.parse(configStr);
        ReactDOM.createRoot(liveTableRoot).render(
            <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
                <LiveTable config={tableConfig} />
            </PersistQueryClientProvider>
        );
    }
}

// Donut charts (dashboard)
document.querySelectorAll<HTMLElement>("[data-donut-chart]").forEach((el) => {
    const labels: string[] = JSON.parse(el.dataset.labels || "[]");
    const values: number[] = JSON.parse(el.dataset.values || "[]");
    const colors: string[] = JSON.parse(el.dataset.colors || "[]");
    const redirectBase = JSON.parse(el.dataset.redirectBase || "null");
    const redirectValues: string[] = JSON.parse(el.dataset.redirectValues || "[]");
    ReactDOM.createRoot(el).render(
        <DonutChart
            labels={labels} values={values} colors={colors}
            redirectBase={typeof redirectBase === "string" ? redirectBase : undefined}
            redirectValues={redirectValues}
        />
    );
});

document.querySelectorAll<HTMLElement>("[data-half-donut-chart]").forEach((el) => {
    const value = Number(el.dataset.value || "0");
    const label = el.dataset.label || undefined;
    const redirectBase = el.dataset.redirectBase || undefined;
    ReactDOM.createRoot(el).render(
        <HalfDonutChart value={value} label={label} redirectBase={redirectBase} />
    );
});

// Toast API — available globally via window.toast
(window as any).toast = toast;

// Toast notification container
const toastRoot = document.createElement("div");
toastRoot.id = "toast-root";
document.body.appendChild(toastRoot);
ReactDOM.createRoot(toastRoot).render(<ToastContainer />);

initUploadFields();
initSelectFields();
initDatePickerFields();
initChangeFormActions();

document.addEventListener('formset:added', (e) => {
    const row = e.target;
    if (!(row instanceof HTMLElement)) return;
    initSelectFields(row);
    initDatePickerFields(row);
});

(window as any).rdMountDateTimePicker = mountDateTimePicker;
// сигнал внешним js, что глобальные api на window готовы к использованию
window.dispatchEvent(new CustomEvent('rd:ready'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
